import { UseFormSetValue } from "react-hook-form";
import Select, {
  SelectClasses,
} from "../../../../../shared/components/UI/Select";

interface Props {
  label: string;
  value: string;
  options: { value: string; label: string }[];
  setValue: UseFormSetValue<any>;
  formName: string;
  classes?: Partial<SelectClasses>;
}

export default function LabeledSelect({
  label,
  value,
  options,
  setValue,
  formName,
  classes,
}: Props) {
  return (
    <div className="cabinet_profileeditmodal-right-content-box">
      <div className="cabinet_profileeditmodal-right-content-box-wrapper">
        <Select
          options={options?.map((option) => option.label)}
          value={value}
          isChangeable
          classes={classes}
          setValue={setValue}
          formName={formName}
        />
        <label className="cabinet_profileeditmodal-right-content-box-wrapper-label">
          {label}
        </label>
      </div>
    </div>
  );
}
